import { AdvancedSearchFormModel } from "./../../search/models/advanced-search-form";
import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { WelcomeListItemModel } from "../../search/models/welcome-list-item";
import { WelcomeListCollection } from "../../search/collections/welcome-list";
import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AppSettings } from "../../app-settings";
import { AppEvents } from "../../app-events";
import { BaseDocumentModel } from "../../desktop/models/base-document";
import { prop} from "../../decorators/property";
import { ReelItemModel, ReelItemType } from "./reel-item";
import { OverviewReelModel } from "./overview-reel";
import { AdvancedSearchModel } from "../../search/models/advanced-search";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "../../shared/helpers/container-helper";

export class OverviewProductReelModel extends OverviewReelModel {

    @prop() public Title = "Collections";
    public Query;
    private data: any;
    private applicationUser = ContainerHelper.AuthService.AppUser;

    constructor() {
        super();
        this.setupEvents();
    }

    public loadData() {
        const key = `my_justis_products:${this.applicationUser.Email}`;
        this.data = window.localStorage.getItem(key);
        if (this.data) {
            this.parseResults();
            return true;
        } else {
            return false;

        }
    }

    private setupEvents() {
        this.appEvents.on(AppEvents.AdvancedSearchFormsLoaded, (data) => this.saveData(data));
    }

    private saveData(model: AdvancedSearchModel) {
        const allGroups = _.flatten(model.SearchForms.map((f) => f.SearchFilterGroups.models));
        const allFilters = _.flatten(allGroups.map((g) => g.Filters.models));
        const productDetails = allFilters.map((f) => {
            return {
                Title: f.DisplayName,
                Description: f.Description,
                Subscribed: f.Subscripted,
                Coverage: f.Coverage,
                Type: f.Type,
                InfoUrl: f.InfoUrl,
            };
        });
        if (this.applicationUser.Email) {
            const key = `my_justis_products:${this.applicationUser.Email}`;
            window.localStorage.setItem(key, JSON.stringify(productDetails));
            this.loadData();
        }
    }

    private parseResults() {
        const jsonData = JSON.parse(this.data);
        this.Items.reset();
        jsonData.forEach((doc) => {
            const model = this.buildItemModel(doc);
            if (model) {
                this.Items.add(model);
            }
        });
    }

    private buildItemModel(doc) {
        try {
            const model = new ReelItemModel();
            model.Title = doc.Title,
            model.Description = doc.Description;
            model.Coverage = doc.Coverage;
            model.Subscribed = doc.Subscribed;
            model.Type = doc.Type;
            model.ItemType = ReelItemType.Product;
            return model;
        } catch (err) {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/overview-product-reel.ts